import React, { useEffect, useState } from 'react';
import { get_ListeAppartenance } from '../api/appartenance';
import { Select } from 'antd';

const {Option} = Select


const ListeAppartenance = ({onchange, valeur}) => {
    const [ListeAppartenance, setListeAppartenance] = useState([])

    useEffect(() => {
        fetchAppartenance()
      
    }, []);

    const fetchAppartenance = async () => {
        const res = await get_ListeAppartenance()
        if (res.status === "success"){
            setListeAppartenance(res.data)
        }
    }
    return (
        <div>
            <Select
                size = 'medium'
                style = {{
                    width: '100%',
                    textAlign: 'center'
                }}
                value={valeur && valeur !== 0 ? valeur : null} 
                onChange={(value) => {
                    if(onchange) onchange(value)
                }}
                placeholder="Choisir une propriété"
            >
                {
                    ListeAppartenance && ListeAppartenance.map(item => {
                        return(
                            <Option key={item['id']} value={item['id']}>{item.nom}</Option>
                        )
                    })
                }
            </Select>
        </div>
    );
}

export default ListeAppartenance;
